export default "__VITE_ASSET__CV3BTtZb__"